"use strict";

import configuration from "../../configuration";
import SystemConfiguration from '../../src/utils/SystemConfiguration'

const url = configuration.apiHost;

export default class SystemConfigurationService {

  static async getConfigurations() {
    try {
      return await SystemConfiguration
    } catch (error) {
      throw new Error(error);
    }
  } // getConfigurations();
} // class



// WEBPACK FOOTER //
// ./src/service/SystemConfigurationService.js